import http from "../http-common";
import authHeader from './authHeader.service';

const API_URL_PATH = '/auth/';

class AuthDataService {

  login(loginFormModel) {
    let body = {email: loginFormModel.email, password: loginFormModel.password}
    return http.post(API_URL_PATH + 'signin', body)
      .then(
        response => {
          if (response.status == 200){
            localStorage.setItem('user', JSON.stringify(response.data));
            return response.data;
          } else {
            return {status:response.status, message: response.data.message}
          }
        },
        error => {
          console.log((error.response && error.response.data) ||
          error.message ||
          error.toString())
          return {status:401, message: error.response.data.message}
        }
      );
  }

  logout() {
    localStorage.removeItem('user');
  }

}

export default new AuthDataService();